import React from 'react'
import Footer from '../../Footer'
import ImageGallery from 'react-image-gallery';
import '../Proj.css'


const images = [
    {
      original: 'https://i.imgur.com/05xzNud.jpg',
      thumbnail: 'https://i.imgur.com/05xzNud.jpg',
    },
    {
      original: 'https://i.imgur.com/bfWOjxJ.jpg',
      thumbnail: 'https://i.imgur.com/bfWOjxJ.jpg',
    },
    {
        original: 'https://i.imgur.com/hdDnH8c.jpg',
        thumbnail: 'https://i.imgur.com/hdDnH8c.jpg',
    },
    {
    original: 'https://i.imgur.com/oOqaa2Q.jpg',
    thumbnail: 'https://i.imgur.com/oOqaa2Q.jpg',
    }
];


export default class ProjFood extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='proj-wrap'>
                    <div id='illust-title'>
                        <h1>Taiwanese Food</h1>
                        <p className='little-title'>Some of my favorite ones. There are so much more!</p>
                    </div>
                </div>
                <div className='proj-image-gallery'>
                    <ImageGallery items={images} />
                </div>
                <Footer back={true}/>
            </div>
                
            
        )
    }
}